import React, { Dispatch, SetStateAction } from "react";
import { Layers, Map, LayoutDashboard } from "../ui/icons";
import LayersModal from "../LayersModal";
import ScenariosModal from "../ScenariosModal";
import MapViewModal from "../MapViewModal";
import {
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerBody,
} from "../ui/shadcn/drawer";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../ui/shadcn/tabs";
import Typography from "../Typography";
import { useLayers } from "../../context/LayersContext";

interface TabComponentProps {
  selectedTab: number;
  setSelectedTab: Dispatch<SetStateAction<number>>;
  onClose: () => void;
}

export default function TabComponent({
  selectedTab,
  setSelectedTab,
  onClose,
}: TabComponentProps) {
  const { cleanCheckedLayers } = useLayers();

  const handleTabChange = (value: string) => {
    const newTab = Number(value);
    if (selectedTab === 1 && newTab === 0) {
      cleanCheckedLayers();
    }
    setSelectedTab(newTab);
  };

  return (
    <Drawer open={true} onClose={onClose}>
      <DrawerContent
        position="left"
        className="left-4 top-[145px] w-[400px] max-h-[calc(100vh-145px-10.5rem)] overflow-y-auto"
      >
        <Tabs value={selectedTab.toString()} onValueChange={handleTabChange}>
          <DrawerHeader>
            <TabsList
              variant="fullWidth"
              className="bg-white text-dark-blue align-center"
            >
              <TabsTrigger
                value="0"
                icon={<Layers size={16} />}
                className="px-2"
              >
                <Typography variant="body4">Camadas</Typography>
              </TabsTrigger>
              <TabsTrigger
                value="1"
                icon={<LayoutDashboard size={16} />}
                className="px-2"
                title="Potencial calculado a partir de restrições ambientais, geográficas e de conexões com a lista de transmissão e subestações existentes"
              >
                <Typography variant="body4">Projeções</Typography>
              </TabsTrigger>
              <TabsTrigger value="2" icon={<Map size={16} />} className="px-2">
                <Typography variant="body4">Mapa Base</Typography>
              </TabsTrigger>
            </TabsList>
          </DrawerHeader>

          <DrawerBody data-tour="drawer-body" className="flex-grow p-4">
            <TabsContent
              value="0"
              data-tour="layers-panel"
              className="mt-0 w-full max-w-full box-border"
            >
              <div>
                <LayersModal />
              </div>
            </TabsContent>
            <TabsContent
              value="1"
              data-tour="projections-panel"
              className="mt-0 w-full max-w-full box-border"
            >
              <div>
                <ScenariosModal />
              </div>
            </TabsContent>
            <TabsContent
              value="2"
              data-tour="base-map-panel"
              className="mt-0 w-full max-w-full box-border"
            >
              <div>
                <MapViewModal />
              </div>
            </TabsContent>
          </DrawerBody>
        </Tabs>
      </DrawerContent>
    </Drawer>
  );
}
